import React from "react";
import { Card } from "antd";
import {
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const config = {
  title: "Expenses vs Client Billing Trend",
  data: [
    { month: "Jan", earning: 10, expense: -270 },
    { month: "Feb", earning: 290, expense: 150 },
    { month: "Mar", earning: 230, expense: 150 },
    { month: "Apr", earning: 150, expense: 10 },
    { month: "May", earning: 290, expense: -270 },
    { month: "Jun", earning: 150, expense: -270 },
    { month: "Jul", earning: 0, expense: 290 },
    { month: "Aug", earning: 290, expense: 150 },
    { month: "Sep", earning: 130, expense: -10 },
    { month: "Oct", earning: 290, expense: -270 },
    { month: "Nov", earning: 290, expense: -270 },
    { month: "Dec", earning: 290, expense: -270 },
  ],
  colors: {
    earning: "#7ED321",
    expense: "#FF4D4F",
  },
};

const ExpensesVsBilling: React.FC = () => {
  return (
    <Card className="rounded-xl mt-4" bodyStyle={{ padding: 24 }}>
      <h2 className="text-base font-semibold text-gray-800 mb-4">
        {config.title}
      </h2>

      <div className="h-[360px]">
        <ResponsiveContainer width="100%" height="100%">
          <ScatterChart
            margin={{ top: 20, right: 30, bottom: 40, left: 40 }}
          >
            <CartesianGrid
              strokeDasharray="4 4"
              vertical={false}
              stroke="#E5E7EB"
            />

            <XAxis
              dataKey="month"
              allowDuplicatedCategory={false}
              type="category"
              tick={{ fill: "#667085", fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />

            <YAxis
              type="number"
              domain={[-300, 300]}
              ticks={[-300, -200, -100, 0, 100, 200, 300]}
              tickFormatter={(v) => `${v}k`}
              tick={{ fill: "#667085", fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />

            <Tooltip cursor={false} />

            <Legend
              verticalAlign="bottom"
              align="left"
              iconType="rect"
              wrapperStyle={{ paddingTop: 16 }}
            />

            <Scatter
              name="Earning"
              data={config.data}
              dataKey="earning"
              fill={config.colors.earning}
              shape="circle"
            />

            <Scatter
              name="Expense"
              data={config.data}
              dataKey="expense"
              fill={config.colors.expense}
              shape="circle"
            />
          </ScatterChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default ExpensesVsBilling;
